<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">企业金融解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          橡诺科技凭借在集团财务公司行业多年的项目实施经验及专业知识积累，形成了一套完整的、科学的、有效的实施方法论，为客户提供丰富的业务咨询、业务系统建设及系统集成服务，相继服务于中油财务公司、中化财务公司、武钢集团财务公司等近百家知名企业。公司为客户提供从业务咨询、IT规划、网络建设、标准产品实施、系统定制化开发、运营维护到后期泛金融业务信息化支持的全生命周期全价值链的一站式解决方案服务。
        </div>
        <div class="title-sub">方案特点</div>
        <div class="text">
          新架构<br>
          基于SOA的先进技术架构，系统耦合性低，全面覆盖支撑财务公司业务拓展及创新。<br>
          新技术<br>
          依托于先进的IAF平台，采用ESB等关键技术，能为项目建设良好的底层架构。<br>
          新应用<br>
          “境内+境外”、“本币+外币”、“现金＋票据”、“集团＋财务公司”、“PC＋移动”等新应用将为客户带来新的体验和业务拓展。<br>
          财务公司整合型全局解决方案<br>
          橡诺科技为财务公司提供从系统咨询（开业辅导、战略规划、业务蓝图）、系统集成（硬件集成、软件集成、机房建设）和业务实施（业务规划、系统支持）三大板块的解决方案服务。<br>
          <div class="img"><img src="@/assets/img/solution/2/1.png"></div>
          财务公司核心业务系统应用架构<br>
          <div class="img"><img src="@/assets/img/solution/2/2.png"></div>
          财务公司核心业务系统分为四个层面，分别是：服务渠道层、业务运营层、集团资管层、基础管理层、数据分析层。<br>
          服务渠道层是财务公司、集团成员单位及未来成员单位上下游客户通过多种途径进行财务公司业务系统操作的通道，如电脑、手机、微信等各类终端。<br>
          基础管理层是财务公司业务系统整体架构中的基础模块，主要包括系统管理、客户管理、审批流程管理等模块。<br>
          业务运营层是财务公司业务系统整体架构中的核心部分，主要分为资金结算、信贷管理、资金预算、纸票管理、资金监控、客户管理、外汇管理、投资管理等功能。同时核心业务层可以与外部银行系统、征信系统、监管系统等进行接口集成。<br>
          集团资管层主要是财务公司在集团授权下，协助集团进行资金计划、资金头寸、筹融资等工作。<br>
          统计分析层主要提供对业务数据和财务数据的分析处理，包括报表管理、监测与预警分析、风险控制管理等功能模块。<br>
          财务公司内部业务人员可以通过局域网进行业务处理，财务公司客户可以通过互联网实现业务处理，业务管理系统与财务/ERP核算系统、业务管理系统和客户网上金融服务系统、业务管理系统内部功能模块实现数据共享、高度集成，减少信息的重复录入，提高业务处理效率。
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>